




import ConfirmTenderEvaluation from '@/views/Tender/Evaluation/ConfirmTenderEvaluation.vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'ConfirmSellingTenderEvaluation',
  components: { ConfirmTenderEvaluation },
})
